import {
  approveGroupRequests as publicApproveGroupRequests,
  rejectGroupRequests as publicRejectGroupRequests,
  listGroupRequests as publicListGroupRequests,
  queryGroupRequests as publicQueryGroupRequests,
  typedQueryGroupRequests as publicTypedQueryGroupRequests,
} from './social-groups-v2-group-request-group-requests.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onGroupRequestApproved as publicOnGroupRequestApproved } from './social-groups-v2-group-request-group-requests.public.js';
import { onGroupRequestCreated as publicOnGroupRequestCreated } from './social-groups-v2-group-request-group-requests.public.js';
import { onGroupRequestRejected as publicOnGroupRequestRejected } from './social-groups-v2-group-request-group-requests.public.js';

export const approveGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicApproveGroupRequests> &
    typeof publicApproveGroupRequests
> = /*#__PURE__*/ createRESTModule(publicApproveGroupRequests);
export const rejectGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicRejectGroupRequests> &
    typeof publicRejectGroupRequests
> = /*#__PURE__*/ createRESTModule(publicRejectGroupRequests);
export const listGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicListGroupRequests> &
    typeof publicListGroupRequests
> = /*#__PURE__*/ createRESTModule(publicListGroupRequests);
export const queryGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicQueryGroupRequests> &
    typeof publicQueryGroupRequests
> = /*#__PURE__*/ createRESTModule(publicQueryGroupRequests);
export const typedQueryGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicTypedQueryGroupRequests> &
    typeof publicTypedQueryGroupRequests
> = /*#__PURE__*/ createRESTModule(publicTypedQueryGroupRequests);
/**
 * Triggered when a group request is approved.
 */
export const onGroupRequestApproved: BuildEventDefinition<
  typeof publicOnGroupRequestApproved
> &
  typeof publicOnGroupRequestApproved = createEventModule(
  publicOnGroupRequestApproved
);
/** */
export const onGroupRequestCreated: BuildEventDefinition<
  typeof publicOnGroupRequestCreated
> &
  typeof publicOnGroupRequestCreated = createEventModule(
  publicOnGroupRequestCreated
);
/**
 * Triggered when a group request is rejected.
 */
export const onGroupRequestRejected: BuildEventDefinition<
  typeof publicOnGroupRequestRejected
> &
  typeof publicOnGroupRequestRejected = createEventModule(
  publicOnGroupRequestRejected
);

export {
  Type,
  AllowPolicy,
  StepKey,
  PrivacyStatus,
  IdentityType,
  RequestStatus,
  ContentType,
  ItemsToUpdate,
  OwnershipFilter,
  SortOrder,
  WebhookIdentityType,
} from './social-groups-v2-group-request-group-requests.universal.js';
export {
  GroupRequest,
  Group,
  Events,
  Logo,
  GroupDetailsPosition,
  Image,
  Position,
  OnboardingStepSettings,
  AccessRestriction,
  AccessRestrictionDataOneOf,
  GroupDetails,
  CoverImage,
  GroupSettings,
  Identity,
  RequestDetails,
  SubmitGroupRequestRequest,
  SubmitGroupRequestResponse,
  ApproveGroupRequestsRequest,
  ApproveGroupRequestsResponse,
  GroupRequestApproved,
  RejectGroupRequestsRequest,
  Rejection,
  RejectGroupRequestsResponse,
  GroupRequestRejected,
  CancelGroupRequestRequest,
  CancelGroupRequestResponse,
  ListGroupRequestsRequest,
  ListGroupRequestsResponse,
  PagingMetadata,
  QueryGroupRequestsRequest,
  Query,
  Sorting,
  Paging,
  QueryGroupRequestsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  GroupRequestApprovedEnvelope,
  GroupRequestCreatedEnvelope,
  GroupRequestRejectedEnvelope,
  ListGroupRequestsOptions,
  QueryGroupRequestsOptions,
  GroupRequestsQueryResult,
  GroupRequestsQueryBuilder,
  GroupRequestQuerySpec,
} from './social-groups-v2-group-request-group-requests.universal.js';
export { utils } from './social-groups-v2-group-request-group-requests.universal.js';
export {
  TypeWithLiterals,
  AllowPolicyWithLiterals,
  StepKeyWithLiterals,
  PrivacyStatusWithLiterals,
  IdentityTypeWithLiterals,
  RequestStatusWithLiterals,
  ContentTypeWithLiterals,
  ItemsToUpdateWithLiterals,
  OwnershipFilterWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  GroupRequestQuery,
} from './social-groups-v2-group-request-group-requests.universal.js';
